import { useState } from 'react';
import { Header } from './ui';
import { IntroScreen } from './screens/IntroScreen';
import { StepsScreen } from './screens/StepsScreen';

type ScreenName = 'intro' | 'steps';
export type ViewMode = 'normal' | 'help' | 'cascade' | 'compact' | 'chat';

export function Wizard() {
  const [screen, setScreen] = useState<ScreenName>('intro');
  const [viewMode, setViewMode] = useState<ViewMode>('normal');

  return (
    <div className="relative h-screen w-full bg-white">
      {screen === 'steps' && viewMode === 'normal' && (
        <Header
          onHelp={() => setViewMode('help')}
          onCascade={() => setViewMode('cascade')}
          onCompact={() => setViewMode('compact')}
          onChat={() => setViewMode('chat')}
        />
      )}
      {screen === 'intro' && <IntroScreen onStart={() => setScreen('steps')} />}
      {screen === 'steps' && (
        <StepsScreen
          onComplete={() => setScreen('intro')}
          onBackToIntro={() => setScreen('intro')}
          viewMode={viewMode}
          onExitMode={() => setViewMode('normal')}
        />
      )}
    </div>
  );
}
